import { Component, Input, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { Observable } from 'rxjs';
import { resumeDataInterface } from '../../interfaces/resume';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-projects-resume',
  templateUrl: 'projects.resume.component.html',
  styleUrls: ['projects.resume.component.css']
})
export class ProjectsResumeComponent implements OnInit {
  @Input() dades: resumeDataInterface;
  @Input() font: string;  

  private unsubscriber : Subject<void> = new Subject<void>();

  constructor(public translate: TranslateService, public languageService: LanguageService){}

  ngOnInit(){
    if(this.font == "project")this.font="DELS TREBALLS";else this.font="DE LES PROPOSTES";
  
    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
